import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
export var logoImage = {
  name: "s9z4f1",
  styles: "height:40px;width:100%;object-fit:contain;"
};
export var logo = background => /*#__PURE__*/css("position:absolute;width:100%;display:block;background-color:", background || tokens.colors.neutral.heavy.default, ";height:48px;text-align:center;padding-top:4px;opacity:0;transition:opacity 500ms;");
export var active = {
  name: "whh5e5",
  styles: "opacity:1;"
};
export var logoContainer = {
  name: "95glwi",
  styles: "display:block;position:relative;height:48px;width:100%;"
};